module.exports = ".block_groups_priority {\n    padding: 15px;\n    overflow-x: hidden;\n    -webkit-box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n            box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    height: calc(100vh - 48px);\n    background-color: #fff;\n    border-radius: 8px;\n    border: 1px solid #e6ebf1;\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/admin/icontact/setting/priority/priority.css
// module id = ./src/app/pages/admin/icontact/setting/priority/priority.css
// module chunks = main